exports.default = {
  locale: {
    'zh-cn': '简体',
    'zh-tw': '繁体',
    'en-us': 'English'
  },
  router: {
    'home': 'Home',
    'image-generation': 'AI Images',
    'video-generation': 'AI Video',
    'web-generation': 'AI Web',
    'user-center': 'User Center',
    'user-set': 'User Settings',
    'team-invitation': 'Member Invitations',
    'team-manage': 'Team Management',
    'team-set': 'Team Settings',
    'team-member-department': 'Member Departments',
    'team-member-approve': 'Member Approval',
    'team-role-management': 'Role Management',
    'team-limit-management': 'Limit Management',
    'team-consumption-records': 'Consumption Records',
    'chat-creation': 'Chat',
    'agent-creation': 'Agent Management',
    'agent-setting': 'Agent Settings',
    'agent-link': 'Connection Integration',
    'agent-data-analysis': 'Data Analysis',
    'agent-user-feedback': 'User Feedback',
    'agent-member-setting': 'Member Settings',
    'chat-apps': 'Agent Center',
    'chat-export': 'Export Chat History',
    'chat-img-mj': 'MidJourney Image Center',
    'chat-img-sd': 'Stable Diffusion Image Center',
    'chat-images-wall': 'Gallery',
    'dashboard': 'Discover',
    'invitation': 'Referral Program',
    'knowledge': 'Projects',
    'knowledge-manage': 'Project Management',
    'asset': 'Assets'
  },
  message: {
  },
  layout: {
  },
  common: {
    please_select: 'Please Select',
    please_enter: 'Please enter',
    operation: 'Operation',
    delete: 'Delete',
    send: 'Send',
    tips: 'Tips',
    confirm: 'Confirm',
    cancel: 'Cancel',
    submit: 'Submit',
    other: 'Other',
    success: 'Success',
    fail: 'Fail',
    user: 'User',
    share: 'Share',
    sign_in: 'Sign In',
    copy: 'Copy'
  }
}
